// Modules
import React from "react";

// Components
import FullMenu from "../Common/fullMobileMenu";

// Layout: Vertical navigation drawer
function VerticalNavDrawer({
  menuItems,
  toggle,
  onToggle,
  PageLevel,
  activeIndex,
  setActiveIndex,
  secondActiveIndex,
  setSecondActiveIndex,
  thirdActiveIndex,
  setThirdActiveIndex,
  useInitials,
  userIsSigned,
  handleUserLogout,
  userType,
  urlPathName,
  pathSegments,
}) {
  // Render
  return (
    <div
      className={`nav_drawer_default
        ${toggle ? "horizontal_overlay" : "no_overlay"}
      `}
    >
      <FullMenu
        onToggle={onToggle}
        menuItems={menuItems}
        PageLevel={PageLevel}
        activeIndex={activeIndex}
        setActiveIndex={setActiveIndex}
        secondActiveIndex={secondActiveIndex}
        setSecondActiveIndex={setSecondActiveIndex}
        thirdActiveIndex={thirdActiveIndex}
        setThirdActiveIndex={setThirdActiveIndex}
        useInitials={useInitials}
        // userProfileImage={userProfileImage}
        userIsSigned={userIsSigned}
        handleUserLogout={handleUserLogout}
        userType={userType}
        urlPathName = {urlPathName}
        pathSegments = {pathSegments}
      />
    </div>
  );
}

// Export
export default VerticalNavDrawer;
